import React from 'react';
import { useTranslation } from 'next-i18next';
import Icon from '@components/atoms/icon/icon';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import styles from './index.module.scss';

const GenericError: React.FC = () => {
  const { t } = useTranslation('pricing-calculator');
  const router = useRouter();

  const handleRedirect = () => {
    router.push('/sell-clothes-online/');
  };

  return (
    <div className={styles.genericError}>
      <section className={styles.genericError__header}>
        <i className={styles.genericError__header__icon}>
          <Icon name="warning-20" />
        </i>
        <h1 className={clsx('vc-text-l', styles.genericError__header__title)}>
          {t('PRICING_CALCULATOR.GENERIC_ERROR.TITLE')}
        </h1>
        <p className={clsx('vc-text-m', styles.genericError__header__text)}>
          {t('PRICING_CALCULATOR.GENERIC_ERROR.BODY')}
        </p>
      </section>
      <section className={styles.genericError__content}>
        <div className={styles.genericError__content__CTA}>
          <button
            className={clsx('vc-btn vc-btn--primary vc-btn--large', styles.genericError__content__CTA__btn)}
            onClick={handleRedirect}
            type="button"
            id="vc-redirect-to-listing-draft-form"
          >
            {t('PRICING_CALCULATOR.GENERIC_ERROR.CTA')}
          </button>
        </div>
      </section>
    </div>
  );
};

export default GenericError;
